import type {
    ColumnDescriptor,
    ColumnProps,
    FilterDescriptor,
    FilterProps,
    Row,
} from "./types.ts";

export const cellPadding = 8;

/* Constants */
const ALIGNMENTS = {
    LEFT: "left",
    CENTER: "center",
    RIGHT: "right",
} as const;

export const transformColumnProps = (
    props: ColumnProps,
    columnIndex: number,
): ColumnDescriptor => {
    const {
        label,
        tooltipText,
        align,
        minWidth,
        maxWidth,
        sortKey,
        onSort,
        isVisibleWithFilter,
        dropOnMobile,
        hiddenOnPrint,
        renderKey,
        children,
        id,
        emptyPlaceHolder,
        testId,
    } = props;

    let sortKeyFn;
    if (typeof sortKey === "function") {
        sortKeyFn = sortKey;
    } else if (typeof sortKey === "string") {
        sortKeyFn = (row: Row) => row[sortKey];
    } else {
        sortKeyFn = null;
    }

    let render;
    if (children) {
        render = children;
    } else if (renderKey) {
        render = (row: Row) => row[renderKey];
    } else {
        render = () => null;
    }

    return {
        label,
        tooltipText,
        align: columnIndex && align ? align : ALIGNMENTS.LEFT,
        minWidth,
        maxWidth,
        sortKeyFn,
        onSort,
        isVisibleWithFilter: isVisibleWithFilter
            ? isVisibleWithFilter
            : () => true,
        dropOnMobile: columnIndex && dropOnMobile ? dropOnMobile : false,
        hiddenOnPrint: hiddenOnPrint || false,
        render,
        id: id || columnIndex,
        emptyPlaceHolder,
        testId,
    };
};

export const transformFilterProps = (
    props: FilterProps,
    filterIndex: number,
): FilterDescriptor => {
    const {label, fn, id, testId} = props;
    return {
        label,
        fn,
        id: id || filterIndex,
        testId,
    };
};
